<template>
  <div style="text-align: center">
    <div
      class="my-4"
      style="color: var(--main-color); font-size: 18px; font-weight: bold"
    >
      {{ $t("Application_Finished") }}
    </div>
    <img
      style="width: 120px; margin: auto"
      src="../../assets/images/svgs/completedStep.svg"
    />
    <div class="mt-3" style="width: 70%; margin: auto; text-align: start">
      {{ $t("Dear_Applicant") }}
    </div>
    <div class="mt-2 mb-5" style="width: 70%; margin: auto; text-align: start">
      {{ $t("finished_messege") }}
    </div>

    <!-- PDF Buttons -->
    <div v-if="applicantInfo && !generatingPdf" class="pdf-buttons mb-4">
      <Button
        :label="$t('View_PDF')"
        icon="pi pi-print ml-2"
        class="btnClass"
        style="border: 3px solid #028bff; padding: 10px 20px"
        @click="openPdfInNewTab"
      />
    </div>

    <div v-else-if="generatingPdf" class="pdf-loading mb-4">
      <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
      <p>{{ $t("Generating_PDF") }}</p>
    </div>

    <div v-else class="pdf-loading mb-4">
      <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
      <p>{{ $t("Loading_PDF") }}</p>
    </div>
    <div v-if="!generatingPdf">
      <Button
        :label="backToMainBtnLabel"
        class="btnClass mt-3"
        @click="backtoMainFn"
      />
    </div>

    <!-- Hidden PDF content -->
    <div
      id="pdf-content"
      style="
        position: absolute;
        left: -9999px;
        width: 800px;
        z-index: -99999 !important;
      "
    >
      <!-- First page with header and content -->
      <div class="pdf-page avoid-break" style="margin: 0">
        <!-- Header at the top -->
        <div class="header-container">
          <div class="pdf-header pdf-header-align-center">
            <!-- Left side (logo) -->
            <div class="pdf-header-content primary-header-left">
              <div style="font-size: 10px; max-width: 300px">
                منظومة الحرم الذكي تحت اشراف نائب رئيس الجامعة لشئون التعليم
                والطلاب
              </div>
              <img
                :src="require('../../assets/images/azharLogo_horizontal.png')"
                alt="Al-Azhar Logo"
                style="width: 50px; height: auto"
              />
            </div>
            <!-- Right side (Arabic text) -->
            <div class="pdf-header-content primary-header-right">
              <div style="font-size: 14px; font-weight: bold">
                الأزهر الشريف
              </div>
              <div style="font-size: 10px">مجمع البحوث الإسلامية</div>
              <div style="font-size: 10px">الإدارة العامة للطلاب الوافدين</div>
            </div>
          </div>
        </div>

        <!-- Basic Information -->
        <h2
          style="
            text-align: center;
            margin: 2px 0;
            font-size: 14px;
            font-weight: bold;
          "
          class="avoid-break"
        >
          {{ $t("Applicant_Basic_Information") }}
        </h2>

        <table
          style="
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 15px;
            font-size: 14px;
          "
          class="avoid-break"
        >
          <tr>
            <td
              style="
                border: 1px solid #ddd;
                padding: 1px;

                font-weight: bold;
                width: 30%;
              "
            >
              {{ $t("fullNameLabel_ar_gardian") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{ applicantInfo?.fullNameAr }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #ddd; padding: 1px; font-weight: bold">
              {{ $t("fullNameLabel_gardian") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{ applicantInfo?.fullNameEn }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #ddd; padding: 1px; font-weight: bold">
              {{ $t("Nationality") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{
                getCurrentLocale() === "ar"
                  ? applicantInfo?.nationDescrAr
                  : applicantInfo?.nationDescrEn
              }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #ddd; padding: 1px; font-weight: bold">
              {{ $t("Passport_No") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{ applicantInfo?.passporNo }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #ddd; padding: 1px; font-weight: bold">
              {{ $t("E-Mail") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{ applicantInfo?.emails ? applicantInfo.emails[0] : "" }}
            </td>
          </tr>
          <tr>
            <td style="border: 1px solid #ddd; padding: 1px; font-weight: bold">
              {{ $t("Mobile_Number") }}
            </td>
            <td style="border: 1px solid #ddd; padding: 1px">
              {{
                applicantInfo?.phones?.length
                  ? applicantInfo?.phones[0]?.replace("+", "")
                  : ""
              }}
            </td>
          </tr>
        </table>

        <!-- Preferences Section (now on first page) -->
        <h2
          style="
            text-align: center;
            margin: 2px 0;
            font-size: 15px;
            font-weight: bold;
          "
          class="avoid-break"
        >
          {{ applicantPreferencesLabel }}
        </h2>

        <table
          :style="{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '1px',
            fontSize:
              applicantInfo?.selectedFacultiesWithItsEntMains?.length >= 25
                ? '12px'
                : '14px',
          }"
          class="avoid-break"
        >
          <thead>
            <tr>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 3px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                #
              </th>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 1px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                {{ $t("Faculty") }}
              </th>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 1px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                {{ $t("Specialization") }}
              </th>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 3px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                #
              </th>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 1px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                {{ $t("Faculty") }}
              </th>
              <th
                style="
                  border: 1px solid #ddd;
                  padding: 1px;
                  background-color: #f2f2f2;
                  text-align: center;
                "
              >
                {{ $t("Specialization") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="i in Math.ceil(
                (applicantInfo?.selectedFacultiesWithItsEntMains?.length || 0) /
                  2
              )"
              :key="i - 1"
            >
              <tr>
                <!-- First column set -->
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{ (i - 1) * 2 + 1 }}
                </td>
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{
                    applicantInfo?.selectedFacultiesWithItsEntMains[(i - 1) * 2]
                      ?.faculty
                  }}
                </td>
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{
                    applicantInfo?.selectedFacultiesWithItsEntMains[(i - 1) * 2]
                      ?.entMain ||
                    (getCurrentLocale() === "ar" ? "غير محدد" : "Not Selected")
                  }}
                </td>

                <!-- Second column set (if exists) -->
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{
                    (i - 1) * 2 + 2 <=
                    (applicantInfo?.selectedFacultiesWithItsEntMains?.length ||
                      0)
                      ? (i - 1) * 2 + 2
                      : ""
                  }}
                </td>
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{
                    applicantInfo?.selectedFacultiesWithItsEntMains[
                      (i - 1) * 2 + 1
                    ]?.faculty || ""
                  }}
                </td>
                <td
                  style="
                    border: 1px solid #ddd;
                    padding: 1px;
                    text-align: center;
                  "
                >
                  {{
                    applicantInfo?.selectedFacultiesWithItsEntMains[
                      (i - 1) * 2 + 1
                    ]?.entMain ||
                    ((i - 1) * 2 + 2 <=
                    (applicantInfo?.selectedFacultiesWithItsEntMains?.length ||
                      0)
                      ? getCurrentLocale() === "ar"
                        ? "غير محدد"
                        : "Not Selected"
                      : "")
                  }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- Added instructions text after preferences table -->
        <div
          style="
            font-size: 12px;
            margin-top: 3px;
            text-align: right;
            direction: rtl;
            padding: 3px;
            border: 1px solid #ddd;
            background-color: #f9f9f9;
          "
          class="avoid-break"
        >
          <p style="font-weight: bold; margin: 1px 0">
            برجاء طباعة الرسالة والتوجه الى مكتب تنسيق الوافدين الطلاب والطالبات
            الكليات الشرعية والمستنفيذين ( بالإدارة العامة للطلاب الوافدين داخل
            مدينة البعوث الإسلامية ) الطلاب والطالبات الكليات النظرية والعلمية (
            بالإدارة العامة لشئون التعليم الدور الثالث مكتب التنسيق )
          </p>
          <div style="display: flex">
            <p>وذلك من اجل انهاء المراجعة والترشيح</p>
            <div style="width: 20%; text-align: left">الاسم:</div>
            <div style="width: 20%; text-align: left">المستلم:</div>
          </div>
        </div>
      </div>

      <!-- Terms and Conditions Section -->
      <div class="pdf-page avoid-break" style="margin: 0">
        <!-- Header at the top -->
        <div class="header-container">
          <div class="pdf-header pdf-header-align-center">
            <!-- Left side (logo) -->
            <div class="pdf-header-content primary-header-left">
              <div style="font-size: 10px; max-width: 300px">
                منظومة الحرم الذكي تحت اشراف نائب رئيس الجامعة لشئون التعليم
                والطلاب
              </div>
              <img
                :src="require('../../assets/images/azharLogo_horizontal.png')"
                alt="Al-Azhar Logo"
                style="width: 50px; height: auto"
              />
            </div>
            <!-- Right side (Arabic text) -->
            <div class="pdf-header-content primary-header-right">
              <div style="font-size: 14px; font-weight: bold">
                الأزهر الشريف
              </div>
              <div style="font-size: 10px">مجمع البحوث الإسلامية</div>
              <div style="font-size: 10px">الإدارة العامة للطلاب الوافدين</div>
            </div>
          </div>
        </div>

        <h3 style="text-align: center; margin: 2px 0" class="avoid-break">
          {{ $t("Terms_N_Conditions") }}
        </h3>

        <!-- Terms and Conditions in two columns -->
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            padding: 0;
            margin: 0;
            font-size: 10px;
          "
          class="avoid-break"
        >
          <tr>
            <!-- Left column (English) -->
            <td
              style="
                width: 50%;
                padding-right: 10px;
                padding-left: 10px;
                vertical-align: top;
                direction: ltr;
                text-align: left;
              "
            >
              <p style="margin: 0; line-height: 1.5">
                I agree and commit to all the conditions, procedures, and rules
                for accepting foreign students at Al-Azhar University<br />
                - I commit to all the conditions and admission rules of the
                university<br />
                - I commit to all the regulations and requirements for enrolling
                in study programs in all faculties of Al-Azhar University<br />
                - I acknowledge that the entered data is correct and that the
                electronic bank payment information is accurate<br />
                - I commit to uploading clear photos of the following documents
                (personal photo, high school certificate, the Qudurat
                certificate for Saudi high school, a valid passport for a period
                of not less than six months from the date of application), and
                all documents should be under the same name<br />
                - Upon registration, I commit to clarifying if my mother is
                Egyptian and must provide proof (applicant's birth certificate,
                national ID card for the mother)<br />
                - I acknowledge full responsibility for my choice of
                preferences<br />
                - I commit to paying the tuition fees in accordance with the
                rules and regulations for foreign students at Al-Azhar
                University<br />
                - I acknowledge and commit that my nomination for the college is
                preliminary and is not final until the submitted documents are
                verified on the official website and authenticated by the
                competent authorities<br />
                - I agree to comply with the deadline for submitting all the
                original documents and acknowledge the accuracy of the
                information provided, the validity of the certificate, and the
                passport. I also assume full responsibility in case of
                submitting documents that contradict what was submitted on the
                official website, otherwise, my nomination will be canceled, and
                I will not be entitled to demand its implementation<br />
                - I agree to cancel my nomination if the competent authorities
                object to my nomination at any time, my nomination will be
                canceled<br />
                - I undertake not to claim a refund for the cash payment for the
                services provided on the official website<br />
                - I agree that registration will be canceled if I apply more
                than once or if I submit incorrect or incomplete documents.<br />
                I pledge that the data I entered on the website is correct and
                that the documents on the website match my original
                documents.<br />
                I undertake to respect the college's regulations and rules, as
                well as the instructions issued by the college administration. I
                pledge to set a good example of proper conduct and to maintain
                daily attendance in accordance with the college timetable. I
                also commit to carrying out any tasks assigned to me by teachers
                and the administration, and to preserve the college's property.
                In the event of non-compliance, I agree to pay all costs.<br />
                I pledge that I am not enrolled or nominated in any college of
                Al-Azhar University, and I have not previously studied or
                obtained a qualification from Al-Azhar University. If there is
                any violation of this, I agree to cancel my nomination and I
                shall not have the right to claim any fees or expenses I have
                paid to the university.<br />
                If I withdraw my file and do not complete the procedures, I
                shall not have the right to claim any fees or tuition expenses I
                have paid.
              </p>
            </td>

            <!-- Right column (Arabic) -->
            <td
              style="
                width: 50%;
                padding-left: 10px;
                padding-right: 10px;
                vertical-align: top;
                direction: rtl;
                text-align: right;
              "
            >
              <p style="margin: 0; line-height: 1.5">
                اوافق والتزم بجميع شروط واجراءات وقواعد قبول الطلاب الوافدين
                بجامعة الازهر <br />
                - التزم بكافة الشروط وقواعد قبول الجامعة <br />
                - التزم بجميع الشروط والضوابط المنظمة للالتحاق بالبرامج الدراسية
                في جميع كليات جامعة الازهر <br />
                - اقر بان البيانات المدخلة صحيحة وان بيانات الدفع الالكتروني
                البنكية صحيحة <br />
                - التزم بتحميل صور واضحة من الاوراق الاتية ( صورة شخصية -
                الشهادة الثانوية - تضاف شهادة القدرات بالنسبة للثانوية السعودية
                - جواز سفر ساري العمل به مدة لا تقل عن ستة اشهر من تاريخ التقديم
                ) علي ان تكون جميع المستندات بنفس الاسم <br />
                - التزم عند التسجيل اذا كانت الام مصرية اقوم بتوضيح ذلك ويجب
                تحميل ما يثبت ذلك (شهادة ميلاد المتقدم - بطاقة الرقم القومي للام
                ) <br />
                - اقر بتحمل المسؤلية الكاملة عن اختيار رغباتي <br />
                - التزم بسداد المصروفات الدراسية طبقا لما تنص عليه قواعد ولوائح
                الطلاب الوافدين بجامعة الازهر <br />
                - اقر والتزم بان ترشيحي للكلية يعد ترشيحا مبدئيا ولا يعد ترشيح
                نهائي الا بعد تقديم الاوراق مطابقة لما تم تقديمه علي الموقع
                الالكتروني معتمدة وموثقة من الجهات المختصة <br />
                - اوافق علي الالتزام بموعيد تقديم اصول الاوراق كاملة واقر بصحة
                البيانات المقدمة وصحة الشهادة و جواز السفر واتحمل المسؤلية
                الكاملة في حالة تقديم اوراق مخالفة لما تم تقديمها علي الموقع
                الالكتروني والا سيكون ترشيحي لاغيا ولا يحق لي المطالبة بتنفيذه
                <br />
                - اوافق علي الغاء ترشيحي في حالة اعتراض الجهات المختصة علي
                ترشيحي في اي وقت يصبح ترشيحي لاغيا <br />
                - اتعهد بعدم المطالبة باسترداد المقابل النقدي للخدمات المقدمة
                علي الموقع الالكتروني <br />
                - اوافق علي ان يتم الغاء التسجيل اذا تقدمت اكثر من مرة او قدمت
                مستندات غير صحيحة او غير مكتملة. <br />
                اتعهد ان البيانات التي قمت بادخالها على الموقع صحيحة وان الأوراق
                الموجودة على الموقع مطابقة للأوراق الاصلية الخاصة بي. <br />
                أتعهد بأن احترم أنظمة ولوائح الكلية و التعليمات التي تصدرها
                إدارة الكلية وان اكون قدوة حسنة للسلوك الامثل وان اكون محافظا
                على الحضور اليومي للدراسة و مواظبا على ذلك وفق الجدول الخاص
                بالكلية، و ان اقوم بالاعمال التي اكلف بها من قبل المعلمين و
                الادارة، وان احافظ على ممتلكات الكلية، و في حالة عدم التزامي
                بذلك اتعهد بدفع جميع التكاليف. <br />
                اتعهد باننى غير مقيدا ولا مرشحا باى كلية من كليات جامعة الازهر.
                واننى لم يسبق لى الدراسة او الحصول على مؤهل من جامعة الازهر. في
                حالة وجود اى ما يخالف ذلك أوافق على الغاء ترشيحى ولا يحق لى
                مطالبة الجامعة باية مصروفات او رسوم قمت بسددها. <br />
                وفي حالة قيامى بسحب الملف وعدم استكمال الإجراءات لايحق يحق لى
                مطالبة الجامعة باية مصروفات او رسوم دراسية قمت بسددها.
              </p>
            </td>
          </tr>
        </table>
      </div>
      <!-- Third Page (Security Form) -->
      <div
        class="pdf-page avoid-break"
        style="margin: 0; color: black; background-color: white"
      >
        <!-- Header with logo and title -->
        <div class="header-container">
          <div class="security-form-header-grid">
            <!-- Far right - Al-Azhar text -->
            <div class="pdf-header-content grid-left">
              <div style="font-weight: bold; font-size: 12px; margin: 0">
                الأزهر الشريف
              </div>
              <div style="font-size: 10px; margin: 0">
                مجمع البحوث الإسلامية
              </div>
              <div style="font-size: 10px; margin: 0">
                الإدارة العامة للطلاب الوافدين
              </div>
            </div>

            <!-- Middle section (contains form button and date) -->
            <div class="grid-middle">
              <!-- Right side - Info form button -->
              <div style="width: 110px; text-align: center; margin-right: 5px">
                <div
                  style="
                    border: 1px solid black;
                    padding: 5px;
                    font-size: 11px;
                    direction: rtl;
                    text-align: center !important;
                  "
                >
                  استمارة معلومات
                </div>
              </div>

              <!-- Center - Date -->
              <div
                style="
                  flex-grow: 1;
                  text-align: center;
                  direction: rtl;
                  max-width: 150px;
                "
              >
                <div style="margin-bottom: 5px">
                  <span style="font-weight: bold">الصادر / </span>
                </div>
                <div class="text-nowrap">
                  <span style="font-weight: bold">التاريخ: </span>
                  <span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                  <span
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                  >
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;٢٠م</span>
                </div>
              </div>
            </div>
            <!-- Left side - Logo -->
            <div class="pdf-header-content grid-right">
              <img
                :src="require('../../assets/images/azharLogo_vertical.png')"
                alt="Al-Azhar Logo"
                style="width: 60px; height: auto; margin: 0 auto"
              />
            </div>
          </div>
        </div>

        <!-- Form Content -->
        <div style="padding: 0 15px; direction: rtl; text-align: right">
          <!-- Student Information -->
          <div
            style="margin: 10px 0; display: flex; justify-content: flex-start"
          >
            <div style="font-weight: bold; margin-left: 5px">
              اسم الطالب/ـة بالكامل باللغة العربية
            </div>
            <span> : </span>
            <div style="width: 200px; margin-right: 5px; font-weight: bold">
              {{ applicantInfo?.fullNameAr }}
            </div>
          </div>

          <div
            style="margin: 10px 0; display: flex; justify-content: flex-start"
          >
            <div style="font-weight: bold; margin-left: 5px">الجنسية</div>
            <span> : </span>
            <div style="width: 100px; margin-right: 5px; font-weight: bold">
              {{ applicantInfo?.nationDescrAr }}
            </div>
          </div>

          <!-- Date fields for birth date -->
          <div
            style="display: flex; gap: 10px; margin: 10px 0; text-align: right"
          >
            <div style="font-weight: bold">تاريخ الميلاد</div>

            <div v-if="applicantInfo?.birthdate" style="font-weight: bold">
              {{ formatDate(applicantInfo?.birthdate) }}
            </div>
            <div
              v-else
              style="
                display: inline-flex;
                justify-content: center;
                direction: rtl;
                flex-wrap: nowrap;
                white-space: nowrap;
              "
            >
              <span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              >
            </div>
          </div>

          <div style="margin: 10px 0; text-align: right">
            <div style="font-weight: bold">
              المؤهل الدراسي: يؤهل للالتحاق بالجامعة
            </div>
          </div>

          <div style="margin: 10px 0; text-align: right">
            <div style="font-weight: bold">سبب الحضور: الدراسة بالجامعة</div>
          </div>

          <div
            style="margin: 10px 0; display: flex; justify-content: flex-start"
          >
            <div style="font-weight: bold; margin-left: 5px">
              عنوان الطالب في مصر بالتفصيل
            </div>
            <span> : </span>
            <div style="margin-right: 5px; font-weight: bold">
              {{
                applicantInfo?.egyptianAddresses
                  ? applicantInfo?.egyptianAddresses[0]
                  : ""
              }}
            </div>
          </div>

          <div
            style="margin: 10px 0; display: flex; justify-content: flex-start"
          >
            <div style="font-weight: bold; margin-left: 5px">
              رقم جواز السفر
            </div>
            <span> : </span>
            <div style="width: 150px; margin-right: 5px; font-weight: bold">
              {{ applicantInfo?.passporNo }}
            </div>
          </div>

          <!-- Date field for passport issue date -->
          <div
            style="display: flex; gap: 10px; margin: 10px 0; text-align: right"
          >
            <div style="font-weight: bold">تاريخ إصدار الجواز</div>

            <div
              v-if="applicantInfo?.passporIssueDate"
              style="font-weight: bold"
            >
              {{ formatDate(applicantInfo?.passporIssueDate) }}
            </div>
            <div
              v-else
              style="
                display: inline-flex;
                justify-content: center;
                direction: rtl;
                flex-wrap: nowrap;
                white-space: nowrap;
              "
            >
              <span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              >
            </div>
          </div>

          <!-- Date field for passport expiry date -->
          <div
            style="display: flex; gap: 10px; margin: 10px 0; text-align: right"
          >
            <div style="font-weight: bold">تاريخ انتهاء الجواز</div>

            <div
              v-if="applicantInfo?.passporExpireDate"
              style="font-weight: bold"
            >
              {{ formatDate(applicantInfo?.passporExpireDate) }}
            </div>
            <div
              v-else
              style="
                display: inline-flex;
                justify-content: center;
                direction: rtl;
                flex-wrap: nowrap;
                white-space: nowrap;
              "
            >
              <span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              ><span>/</span
              ><span style="color: #333; padding: 0 5px; margin: 0 2px"
                >[&nbsp;&nbsp;&nbsp;&nbsp;]</span
              >
            </div>
          </div>

          <!-- Signature Section -->
          <div
            style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: space-between;
              margin: 30px 0 20px;
            "
          >
            <div style="text-align: center">
              <div style="font-weight: bold">يعتمد؛</div>
              <div style="font-weight: bold">
                مدير عام الإدارة العامة للطلاب الوافدين
              </div>
              <div
                style="
                  border-bottom: 1px solid #000;
                  width: 250px;
                  margin-top: 30px;
                "
              ></div>
            </div>
            <div style="text-align: center">
              <div style="font-weight: bold">المختص/</div>
              <div
                style="
                  border-bottom: 1px solid #000;
                  width: 150px;
                  margin-top: 30px;
                "
              ></div>
            </div>
          </div>

          <!-- Security Section 1 -->
          <div
            style="
              margin: 20px 0;
              text-align: right;
              border-top: 2px solid black;
            "
          >
            <div style="font-weight: bold; margin-bottom: 10px">
              السيد اللواء نائب رئيس هيئة الأمن القومي
            </div>
            <div style="margin-bottom: 10px; text-align: center">
              تحية طيبة وبعد،،،
            </div>
            <div style="margin-bottom: 10px">
              نرجو التفضل بالإفادة بالرأي نحو قبول الطالب المذكور اسمه عاليه.
            </div>
            <div style="margin: 20px 0; text-align: center">
              <div>ولسيادتكم وافر الشكر</div>
              <div style="text-align: left !important; font-weight: bold">
                مدير عام أمن الأزهر
              </div>
              <div style="margin-top: 10px; display: flex">
                <span>تحريرا في</span>
                <div
                  style="
                    border-bottom: 1px solid #000;
                    width: 30px;
                    margin: 0 5px;
                  "
                ></div>
                <span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>
                <div
                  style="
                    border-bottom: 1px solid #000;
                    width: 30px;
                    margin: 0 5px;
                  "
                ></div>
                <span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>
              </div>
              <div
                style="
                  border-bottom: 1px solid #000;
                  width: 200px;
                  margin-top: 20px;
                "
              ></div>
            </div>
          </div>

          <!-- Security Section 2 -->
          <div
            style="
              margin: 0px 0;
              padding-top: 3px;
              text-align: right;
              border-top: 2px solid black;
            "
          >
            <div style="font-weight: bold; margin-bottom: 10px">
              السيد الأستاذ مدير عام أمن الأزهر الشريف
            </div>
            <div style="margin-bottom: 10px">تحية طيبة وبعد ،،،</div>
            <div style="margin-bottom: 10px">
              نعيد لسيادتكم صورة النموذج الخاص بالطالب المذكور بعاليه .....
              ونفيد:
            </div>
            <div
              style="
                border-bottom: 1px dotted black;
                height: 20px;
                margin: 10px 0;
              "
            ></div>
            <div
              style="
                border-bottom: 1px dotted black;
                height: 20px;
                margin: 10px 0;
              "
            ></div>
            <div style="margin: 20px 0; text-align: center">
              <div>ونشكر لسيادتكم حسن تعاونكم معنا،،،</div>
              <div
                style="margin-top: 10px; font-weight: bold; text-align: left"
              >
                السيد اللواء نائب رئيس هيئة الأمن القومي
              </div>
              <div
                style="
                  border-bottom: 1px dotted #000;
                  width: 200px;
                  margin: 20px auto;
                "
              ></div>
            </div>
          </div>

          <div style="text-align: right; margin-top: 3px">
            <div>صورة مرسلة الى السيد الأستاذ مدير عام الطلاب الوافدين</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: "FinishedApplication",
  data() {
    return {
      submitted: false,
      validationErrors: {},
      generatingPdf: false,
    };
  },
  computed: {
    ...mapGetters({
      applicantInfo: "Finished/getApplicantPrintInformation",
    }),
    applicantPreferencesLabel() {
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      const locale = this.getCurrentLocale() === "ar" ? "ar-EG" : "en-US";
  const formatter = new Intl.NumberFormat(locale, { useGrouping: false });

      return this.$t("Applicant_Preferences", {
        currentYear: formatter.format(currentYear),
        nextYear: formatter.format(nextYear)  ,
      });
    },
    backToMainBtnLabel() {
      return this.$t("backToMainBtnLabel");
    },
  },
  methods: {
    backtoMainFn() {
      this.$store.dispatch("navigation/changeTab", 0);
    },
    getCurrentLocale() {
      return localStorage.getItem("locale") || "ar";
    },
    formatAddressList(addressList) {
      if (
        !addressList ||
        !Array.isArray(addressList) ||
        addressList.length === 0
      ) {
        return "";
      }

      // Filter out empty strings and join with dash
      const filteredAddresses = addressList.filter(
        (addr) => addr && addr.trim() !== ""
      );

      if (filteredAddresses.length === 0) {
        return "";
      }

      return filteredAddresses.join(" - ");
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    openPdfInNewTab() {
      if (!this.applicantInfo || this.generatingPdf) return;

      // Set the generating flag to prevent multiple clicks
      this.generatingPdf = true;

      // Use Vue's nextTick to ensure DOM is updated before we access it
      this.$nextTick(() => {
        const pdfElement = document.getElementById("pdf-content");

        if (!pdfElement) {
          console.error("PDF content element not found");
          this.generatingPdf = false;
          return;
        }

        // No need to change display style - content is positioned off-screen
        const originalPosition = pdfElement.style.left;
        // Already rendered but invisible to user

        // Find all page elements
        const pageNodes = Array.from(pdfElement.querySelectorAll(".pdf-page"));

        // If no explicit pages are found, fall back to rendering the whole document
        if (pageNodes.length === 0) {
          this.renderFullPdf(pdfElement, originalPosition);
          return;
        }

        // Create PDF with multiple pages
        this.renderPdfByPages(pageNodes, originalPosition);
      });
    },

    async renderPdfByPages(pageNodes, originalPosition) {
      if (!pageNodes || pageNodes.length === 0) {
        console.error("No page nodes found for PDF rendering");
        this.generatingPdf = false;
        return;
      }

      try {
        // Create PDF document
        const pdf = new jsPDF({
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true,
          hotfixes: ["px_scaling"],
        });

        const pageWidth = pdf.internal.pageSize.getWidth();

        // Process each page
        for (let i = 0; i < pageNodes.length; i++) {
          const pageNode = pageNodes[i];

          // Skip if the page node is no longer in the document
          if (!document.body.contains(pageNode)) {
            console.warn(
              `Page node at index ${i} is no longer in the document`
            );
            continue;
          }

          // Render current page to canvas
          const canvas = await html2canvas(pageNode, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            letterRendering: true,
            backgroundColor: "#ffffff",
            logging: false,
            windowWidth: 800,
          });

          // Add a new page for all but the first page
          if (i > 0) {
            pdf.addPage();
          }

          // Calculate dimensions, maintaining aspect ratio
          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          // Single page rendering approach for all pages
          pdf.addImage(
            canvas.toDataURL("image/png"),
            "PNG",
            0,
            0,
            imgWidth,
            imgHeight
          );
        }

        // Handle opening PDF in new tab
        this.openPdfOutput(pdf, "Applicant_Information.pdf");
      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        // Always restore original display and reset flag
        this.$nextTick(() => {
          const pdfElement = document.getElementById("pdf-content");
          if (pdfElement) {
            pdfElement.style.left = originalPosition;
          }
          this.generatingPdf = false;
        });
      }
    },

    renderFullPdf(pdfElement, originalPosition) {
      if (!pdfElement) {
        console.error("PDF element not provided for rendering");
        return;
      }

      // Use html2canvas to render the whole element
      html2canvas(pdfElement, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: "#ffffff",
        logging: false,
        windowWidth: 800,
      })
        .then((canvas) => {
          // Restore original display style
          this.$nextTick(() => {
            if (pdfElement && document.body.contains(pdfElement)) {
              pdfElement.style.left = originalPosition;
            }
          });

          // Prepare jsPDF document
          const pdf = new jsPDF({
            unit: "mm",
            format: "a4",
            orientation: "portrait",
            compress: true,
            hotfixes: ["px_scaling"],
          });

          const pageWidth = pdf.internal.pageSize.getWidth();
          const imgData = canvas.toDataURL("image/png");

          // Calculate the image dimensions to fit A4 while keeping aspect ratio
          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          // Add the image to the PDF
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

          // Handle opening PDF in new tab
          this.openPdfOutput(pdf, "Applicant_Information.pdf");
        })
        .catch((error) => {
          // Restore display even on error
          this.$nextTick(() => {
            if (pdfElement && document.body.contains(pdfElement)) {
              pdfElement.style.left = originalPosition;
            }
          });
          console.error("Error generating PDF:", error);
        });
    },

    openPdfOutput(pdf, filename) {
      try {
        // Create blob from PDF
        const pdfBlob = pdf.output("blob");
        const blobUrl = URL.createObjectURL(pdfBlob);

        // Try to open in new tab
        const newWindow = window.open();

        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          // Pop-up was blocked, offer download instead
          console.warn("Pop-up blocked. Offering download instead.");
          pdf.save(filename);
        } else {
          // Set the blob URL as the source for the new window
          newWindow.document.title = filename;
          newWindow.location.href = blobUrl;

          // Clean up the blob URL after the PDF has loaded
          newWindow.onload = function () {
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
          };
        }
      } catch (error) {
        console.error("Error opening PDF:", error);
        // Fallback to direct download if opening fails
        try {
          pdf.save(filename);
        } catch (saveError) {
          console.error("Error saving PDF:", saveError);
        }
      } finally {
        this.generatingPdf = false;
      }
    },
  },

  created() {
    try {
      this.$store.dispatch("Finished/printApplicantInformation");
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style scoped>
:deep(.p-button-icon) {
  font-size: 20px;
}

.btnClass {
  font-size: 21px;
  cursor: pointer;
}

/* PDF Specific Styles */
#pdf-content {
  overflow: hidden;
  max-width: 800px;
  font-family: Arial, sans-serif;
}

.pdf-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.pdf-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.pdf-page {
  position: relative;
  padding: 15px;
  margin: 0;
  page-break-inside: avoid;
  page-break-after: always;
}

.header-container {
  margin-bottom: 1px !important;
  width: 100%;
  page-break-inside: avoid;
  page-break-after: avoid;
  box-sizing: border-box;
}

.pdf-content-area {
  padding: 0;
  margin: 0;
  z-index: -99999999999999999 !important;
  display: none;
  page-break-inside: avoid;
}

@media print {
  .pdf-page {
    margin: 0;
    padding: 15px;
    page-break-inside: avoid;
    page-break-after: always;
  }

  .header-container {
    margin-bottom: 1px;
    width: 100%;
    page-break-inside: avoid;
    page-break-after: avoid;
  }

  img {
    page-break-inside: avoid;
    max-width: 100%;
  }

  table {
    page-break-inside: avoid;
    margin: 0;
    padding: 0;
  }

  h2,
  h3 {
    margin: 2px 0;
    padding: 0;
    page-break-after: avoid;
    page-break-before: avoid;
  }

  tr,
  td,
  th {
    page-break-inside: avoid;
  }
}

.avoid-break {
  page-break-inside: avoid;
}

.page-break-after {
  page-break-after: always;
}

.page-break-before {
  page-break-before: always;
}

.pdf-header {
  display: flex;
  justify-content: space-between;
  padding: 3px;
  width: 100%;
  margin: 0;
  border: 0;
  box-sizing: border-box;
}

.pdf-header-align-center {
  align-items: center;
}

.pdf-header-align-top {
  align-items: flex-start;
}

.pdf-header-content {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

/* Ensure consistent header and font sizes */
.pdf-header-content img {
  display: block;
  margin: 3px 0;
}

.pdf-header-content div {
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

/* Ensure all RTL content is properly right-aligned */
[dir="rtl"],
[style*="direction: rtl"] {
  text-align: right !important;
}

/* Special styles for the first and second header */
.primary-header-left {
  text-align: right;
  flex: 1;
}

.primary-header-right {
  text-align: left;
  direction: rtl;
  flex: 1;
}

/* Special class for the third header with four columns */
.pdf-header-four-column {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Style to ensure consistent spacing in the third header */
.security-form-header {
  margin: 0 !important;
  padding: 0 !important;
}

/* Fix for the right header in the third page */
.pdf-header-four-column > div:last-child {
  text-align: right !important;
  align-self: flex-start;
  direction: rtl;
}

/* Grid layout for the security form header */
.security-form-header-grid {
  display: grid;
  grid-template-columns: 180px 1fr 200px;
  width: 100%;
  align-items: start;
  grid-gap: 5px;
  padding: 3px;
  box-sizing: border-box;
}

/* Specific alignments for grid items */
.grid-right {
  text-align: center;
  justify-self: end;
}

.grid-middle {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: flex-start;
}

.grid-left {
  text-align: left;
  direction: rtl;
  justify-self: start;
}

/* Fix text alignment in grid items */
.grid-left > div {
  text-align: right !important;
  width: 100%;
  float: right;
  clear: both;
  display: block;
}
.text-nowrap {
  white-space: nowrap;
}
</style>
